import React, { useState, useEffect } from 'react'
import {
    makeStyles,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Button,
} from '@material-ui/core/'
import { Alert } from '@material-ui/lab'
import Professional from '../../services/Professional'
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
    main_content: {
        marginTop: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    btn: {
        marginRight: '10px'
    },
    table: {
        width: '100%'
    }
})

export default function PatientManager() {
    const classes = useStyles()
    const history = useHistory()
    const [patientData, setPatientData] = useState(JSON.parse(localStorage.getItem('patients')))
    const [error, setError] = useState(false)

    // useEffect(() => {
    //     async function fetchApi() {
    //         try {
    //             const response = await Professional.getAll()
    //             setProfessionalsData(response.data)
    //         } catch (err) {
    //             setError(true)
    //         }
    //     }
    //     fetchApi()
    // }, [])

    const handleDelete = async (email) => {
        try {
            // await Professional.delete(id)
            // const updatedProfessionals = professionalsData.filter((data) => data._id !== id)
            // setProfessionalsData(updatedProfessionals)
            // setError(false)
            const updatedPatients = patientData.filter((data) => data.email !== email)
            setPatientData(updatedPatients)
            setError(false)
            localStorage.setItem('patients',JSON.stringify(updatedPatients))
        } catch (error) {
            setError(true)
        }
    }

    return (
        <>
            {error ? (<Alert
                severity="error">
                Ocorreu um problema ao tentar se comunicar com o servidor
                , tente novamente!
            </Alert>) : null}
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Tel</TableCell>
                            <TableCell>Gender</TableCell>
                            <TableCell>Age</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {patientData ? 
                            (patientData?.map((row) => (
                                <TableRow key={row.name}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.tel}</TableCell>
                                    <TableCell>{row.gender}</TableCell>
                                    <TableCell>{row.age}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={classes.btn}
                                            onClick={() => {
                                                history.push({
                                                    pathname: "patients/edit",
                                                    state: { data: row }
                                                })
                                            }
                                            }
                                        >
                                            Editar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className={classes.btn}
                                            onClick={() => handleDelete(row.email)}
                                        >
                                            Excluir
                                        </Button>
                                        <Button
                                            variant="contained"
                                            className={classes.btn}
                                            onClick={() => history.push("patients/timeline")}
                                        >
                                            Linha do tempo
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))) : <span>Carregando...</span> }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
